import List from '../../containers/Banners/List';
import Entry from '../../containers/Banners';

const bannerRoutes = [
  {
    path: '/banners',
    exact: true,
    auth: true,
    component: List,
  },
  {
    path: '/banners/:type',
    exact: true,
    auth: true,
    component: Entry,
  },
  {
    path: '/banners/:type/:id',
    exact: true,
    auth: true,
    component: Entry,
  }
];

export default bannerRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/banners.jsx